import Icon from "@mui/material/Icon";

const routes = [
  {
    name: "serviços",
    icon: <Icon>architecture</Icon>,
    route: "/servicos",
  },
  {
    name: "sobre nós",
    icon: <Icon>apartment</Icon>,
    route: "/",
  },
  {
    name: "portfólio",
    icon: <Icon>photo_library</Icon>,
    route: "/portfolio",
  },
  {
    name: "time",
    icon: <Icon>groups</Icon>,
    route: "/time",
  },
  {
    name: "blog",
    icon: <Icon>article</Icon>,
    route: "/blog",
  },
  {
    name: "contato",
    icon: <Icon>call</Icon>,
    route: "/contato",
  },
];

export default routes;
